import { createHtmlElement, ElementStyle } from './create-html-element';

export const HEADER_HEIGHT = '60px';

export const createPopupModalHeaderElement = (heading: string = ''): HTMLElement => {
  const headerStyles: ElementStyle[] = [
    { property: 'height', value: HEADER_HEIGHT },
    { property: 'width', value: '100%' },
    { property: 'background', value: '#212121' },
    { property: 'display', value: 'flex' },
    { property: 'justify-content', value: 'center' },
    { property: 'align-items', value: 'center' },
  ];
  const headerElement = createHtmlElement('div', headerStyles);

  if (heading) {
    const headingElement = createHtmlElement('h3', [{ property: 'margin', value: '0' }]);
    headingElement.innerText = heading;
    headerElement.appendChild(headingElement);
  }

  return headerElement;
};
